import {documentLoadEvent} from "../../../webpack/modules/events";
import {initHeaderMessagesSlider} from "../../../webpack/modules/header-messages-slider";

documentLoadEvent(function() {
    initHeaderMessagesSlider();
});